<script setup>
  import { computed } from 'vue';
  import { useI18n } from 'vue-i18n';
  import WidgetBlock from '@/components/WidgetBlock.vue';
  import WidgetEmbedFrame from '@/components/WidgetEmbedFrame.vue';
  import { useWidgetStore } from '@/stores/WidgetStore';
  import { useGoogleAnalyticsStore } from '@/stores/GoogleAnalyticsStore';

  const widgetStore = useWidgetStore();
  const googleAnalyticsStore = useGoogleAnalyticsStore();

  const props = defineProps({
    // A WIDGET_DEFINITIONS id from WidgetStore ('liveWind', 'windMap', …)
    widgetId: {
      type: String,
      required: true
    }
  });

  const { t } = useI18n();

  const definition = computed(() => widgetStore.getDefinition(props.widgetId));
  const embed = computed(() => widgetStore.embeds[props.widgetId]);
  const title = computed(() => t(definition.value.titleKey));

  function handleCustomize() {
    widgetStore.customize(props.widgetId);

    googleAnalyticsStore.sendEvent('Web_Widget_Customizer_Opened', {
      Spot_Name: widgetStore.analyticsSpotName,
      Widget: definition.value.analyticsName,
      Location: 'Main Page'
    });
  }

  function handleCopied() {
    googleAnalyticsStore.sendEvent('Web_Widget_Embed_Copied', {
      Spot_Name: widgetStore.analyticsSpotName,
      Widget: definition.value.analyticsName,
      Location: 'Main Page'
    });
  }
</script>

<template>
  <WidgetBlock
    v-if="embed"
    @customize="handleCustomize"
    @copied="handleCopied"
    :title="title"
    :code="embed.code"
    :previewWidth="embed.width"
    :previewHeight="embed.height"
  >
    <template #preview>
      <WidgetEmbedFrame :widgetId="props.widgetId" />
    </template>
  </WidgetBlock>
</template>
